import { render, staticRenderFns } from "./DocumentIcreas.vue?vue&type=template&id=c0808f44&"
import script from "./DocumentIcreas.vue?vue&type=script&lang=js&"
export * from "./DocumentIcreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports